module.exports = __webpack_public_path__ + "static/img/2.762a956.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/2/eng/2.png
// module id = iW54
// module chunks = 0